var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{staticClass:"mb-3",attrs:{"no-body":""}},[_c('b-card-body',{staticClass:"p-2 p-md-3"},[_c('div',{staticClass:"Chart"},[_c('highcharts',{attrs:{"options":_vm.chartOptions}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }